import { NmbrsService } from '../../../services/nmbrs.service';

class NmbrsTestController implements ng.IComponentController {
    private endpoints: any[] = [];
    private selectedEndpoint: any = null;
    private endpointParams: any = {};
    private result: any = null;
    private loading: boolean = false;
    private error: string = null;

    constructor(
        private NmbrsService: NmbrsService
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.endpoints = [
            {
                name: 'All Employees By Company (Functions)',
                method: 'GET',
                path: 'allEmployeesByCompanyFunctions',
                description: 'Function_GetAll_AllEmployeesByCompany V2: alle medewerkers met functies. Optioneel zoeken op naam.',
                params: [
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null },
                    { key: 'nameSearch', label: 'Zoeken op naam (optional)', type: 'text', value: null }
                ]
            },
            {
                name: 'Labour Agreements',
                method: 'GET',
                path: 'labourAgreements',
                description: 'Get all labour agreements for a company',
                params: [
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee',
                method: 'GET',
                path: 'employee/{employeeId}',
                description: 'Get employee personal info',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Address',
                method: 'GET',
                path: 'employeeAddress/{employeeId}',
                description: 'Get employee address',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Bank Account',
                method: 'GET',
                path: 'employeeBankAccount/{employeeId}',
                description: 'Get employee bank account',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Function',
                method: 'GET',
                path: 'employeeFunction/{employeeId}',
                description: 'Get employee function',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Salary',
                method: 'GET',
                path: 'employeeSalary/{employeeId}',
                description: 'Get employee salary',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Salary List',
                method: 'GET',
                path: 'employeeSalaryList/{employeeId}',
                description: 'Get all salary within given period',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null },
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() }
                ]
            },
            {
                name: 'Employee Wage Component Fixed (Current)',
                method: 'GET',
                path: 'employeeWageComponentFixed/{employeeId}',
                description: 'Get all fixed wage components for the current period',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Wage Component Variable',
                method: 'GET',
                path: 'employeeWageComponentVar/{employeeId}',
                description: 'Get all variable wage components for given period',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null },
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() }
                ]
            },
            {
                name: 'Employee Wage Component Variable (Current)',
                method: 'GET',
                path: 'employeeWageComponentVarCurrent/{employeeId}',
                description: 'Get all variable wage components for the current period',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Contract',
                method: 'GET',
                path: 'employeeContract/{employeeId}',
                description: 'Get employee contract',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Extra Fields',
                method: 'GET',
                path: 'employeeExtraFields/{employeeId}',
                description: 'Get employee extra fields list',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Employee Cost Center (Current)',
                method: 'GET',
                path: 'employeeCostCenter/{employeeId}',
                description: 'Get all active cost centers of a specific employee on the current period',
                params: [
                    { key: 'employeeId', label: 'Employee ID', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Tables',
                method: 'GET',
                path: 'salaryTables',
                description: 'Get salary tables for a company',
                params: [
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Tables V2',
                method: 'GET',
                path: 'salaryTables2',
                description: 'Get salary tables V2 for a company (with GUID)',
                params: [
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Scales',
                method: 'GET',
                path: 'salaryScales',
                description: 'Get salary scales for a company',
                params: [
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Scales V2',
                method: 'GET',
                path: 'salaryScales2',
                description: 'Get salary scales V2 for a company (with GUID)',
                params: [
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Steps',
                method: 'GET',
                path: 'salarySteps',
                description: 'Get salary steps for a specific scale',
                params: [
                    { key: 'scale', label: 'Scale', type: 'text', value: null },
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Salary Steps V2',
                method: 'GET',
                path: 'salarySteps2',
                description: 'Get salary steps V2 for a specific scale (with GUID)',
                params: [
                    { key: 'scale', label: 'Scale', type: 'text', value: null },
                    { key: 'period', label: 'Period (month)', type: 'number', value: new Date().getMonth() + 1 },
                    { key: 'year', label: 'Year', type: 'number', value: new Date().getFullYear() },
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Wage Codes',
                method: 'GET',
                path: 'wageCodes',
                description: 'Returns wage codes that belong to a company\'s wagemodel',
                params: [
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Wage Codes 2',
                method: 'GET',
                path: 'wageCodes2',
                description: 'Returns wage codes that belong to a company\'s wagemodel 2',
                params: [
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Hour Codes',
                method: 'GET',
                path: 'hourCodes',
                description: 'Get hour codes that belong to a company\'s hour model',
                params: [
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Hour Codes 2',
                method: 'GET',
                path: 'hourCodes2',
                description: 'Get hour codes that belong to a company\'s hour model 2',
                params: [
                    { key: 'companyId', label: 'Company ID (optional)', type: 'number', value: null }
                ]
            },
            {
                name: 'Get All Companies',
                method: 'GET',
                path: 'companies',
                description: 'Returns all companies',
                params: []
            }
        ];
    }

    selectEndpoint = (endpoint: any) => {
        this.selectedEndpoint = endpoint;
        this.endpointParams = {};
        this.result = null;
        this.error = null;
        
        // Initialize params with default values
        if (endpoint.params) {
            endpoint.params.forEach((param: any) => {
                this.endpointParams[param.key] = param.value;
            });
        }
    }

    callEndpoint = () => {
        if (!this.selectedEndpoint) {
            return;
        }

        this.loading = true;
        this.result = null;
        this.error = null;

        let path = this.selectedEndpoint.path;
        let queryParams: any = {};

        // Replace path parameters
        if (this.selectedEndpoint.params) {
            this.selectedEndpoint.params.forEach((param: any) => {
                if (path.includes(`{${param.key}}`)) {
                    path = path.replace(`{${param.key}}`, this.endpointParams[param.key]);
                } else {
                    // Add as query parameter if it has a value
                    if (this.endpointParams[param.key] !== null && this.endpointParams[param.key] !== undefined && this.endpointParams[param.key] !== '') {
                        queryParams[param.key] = this.endpointParams[param.key];
                    }
                }
            });
        }

        this.NmbrsService.customGet(path, queryParams)
            .then((response: any) => {
                this.result = response;
                this.loading = false;
            })
            .catch((error: any) => {
                this.error = (error.data && error.data.message) || error.statusText || 'An error occurred';
                this.result = null;
                this.loading = false;
            });
    }

    formatJson = (obj: any) => {
        if (!obj) {
            return '';
        }
        
        // If it's already a string, try to parse it first
        if (typeof obj === 'string') {
            try {
                obj = JSON.parse(obj);
            } catch (e) {
                // If parsing fails, return as is
                return obj;
            }
        }
        
        // Format with proper indentation (2 spaces)
        return JSON.stringify(obj, null, 2);
    }
}

export const nmbrsTestComponent: ng.IComponentOptions = {
    controller: NmbrsTestController,
    template: <string>require('./nmbrsTest.html')
};




// WEBPACK FOOTER //
// ./src/app/modules/settings/nmbrsTest/nmbrsTest.component.ts